export const createCookie = (name, value, expiryDate) => {
  let d = new Date();
  d.setTime(d.getTime() + expiryDate * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = `${name}=${value};${expires};`;
};
